import type { PerformanceResource } from "@solvari/statamic";
import type { LocaleMorpheus } from "@solvari/translations";

import type { StatamicPreview } from "~/shared/composables/useStatamicPreview.ts";

import { useCmsEntryQuery } from "~/shared/composables/useCmsApi.ts";

function usePerformancePage(
  params: { locale: LocaleMorpheus; uri: string },
  preview?: StatamicPreview,
) {
  return useCmsEntryQuery<PerformanceResource>(
    {
      blueprint: "performance",
      collection: "pages",
      locale: params.locale,
      uri: params.uri,
    },
    preview,
  );
}

export { usePerformancePage };
